/* eslint-disable no-loss-of-precision */
import Mouth01 from '../Mouth/Mouth01'
import Mouth02 from '../Mouth/Mouth02'
import Mouth03 from '../Mouth/Mouth03'
import Mouth04 from '../Mouth/Mouth04'
import Mouth05 from '../Mouth/Mouth05'
import Mouth06 from '../Mouth/Mouth06'
import Mouth07 from '../Mouth/Mouth07'
import Mouth08 from '../Mouth/Mouth08'
import Mouth09 from '../Mouth/Mouth09'
import Mouth10 from '../Mouth/Mouth10'
import Mouth11 from '../Mouth/Mouth11'
import Mouth12 from '../Mouth/Mouth12'
import Mouth13 from '../Mouth/Mouth13'
import Mouth14 from '../Mouth/Mouth14'
import Mouth15 from '../Mouth/Mouth15'
import Mouth16 from '../Mouth/Mouth16'
import Mouth17 from '../Mouth/Mouth17'

const data = [
  {
    id: 'Mouth10',
    svg: Mouth10,
    positioning: {
      pointNarrow: {
        y: 126.8863525390625,
        scaleX: 1,
      },
      pointMedium: {
        y: 127.99162292480469,
        scaleX: 1,
      },
      pointWide: {
        y: 126.08561706542969,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 128.02865600585938,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.75390625,
        scaleX: 1,
      },
      roundWide: {
        y: 127.86749267578125,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 125.04461669921875,
        scaleX: 1,
      },
      squareMedium: {
        y: 126.74595642089844,
        scaleX: 1,
      },
      squareWide: {
        y: 126.62980651855469,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Mouth01',
    svg: Mouth01,
    positioning: {
      pointNarrow: {
        y: 124.54161071777344,
        scaleX: 1,
      },
      pointMedium: {
        y: 125.87870788574219,
        scaleX: 1,
      },
      pointWide: {
        y: 124.22047424316406,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 126.06898498535156,
        scaleX: 1,
      },
      roundMedium: {
        y: 127.59286499023438,
        scaleX: 1.05,
      },
      roundWide: {
        y: 126.67266845703125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 125.00750732421875,
        scaleX: 1,
      },
      squareMedium: {
        y: 124.82453918457031,
        scaleX: 1,
      },
      squareWide: {
        y: 126.50553894042969,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Mouth04',
    svg: Mouth04,
    positioning: {
      pointNarrow: {
        y: 124.88722229003906,
        scaleX: 1,
      },
      pointMedium: {
        y: 126.63362121582031,
        scaleX: 1,
      },
      pointWide: {
        y: 123.31846618652344,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 125.59750366210938,
        scaleX: 1,
      },
      roundMedium: {
        y: 126.73214721679688,
        scaleX: 1,
      },
      roundWide: {
        y: 127.15383911132812,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 123.55984497070312,
        scaleX: 1,
      },
      squareMedium: {
        y: 124.71258544921875,
        scaleX: 1,
      },
      squareWide: {
        y: 125.46952819824219,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Mouth07',
    svg: Mouth07,
    positioning: {
      pointNarrow: {
        y: 126.82337951660156,
        scaleX: 1,
      },
      pointMedium: {
        y: 128.16064453125,
        scaleX: 1,
      },
      pointWide: {
        y: 125.04806518554688,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 128.00697326660156,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.5011749267578,
        scaleX: 1.05,
      },
      roundWide: {
        y: 127.69281005859375,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 125.6280517578125,
        scaleX: 1,
      },
      squareMedium: {
        y: 126.72491455078125,
        scaleX: 1,
      },
      squareWide: {
        y: 125.90890502929688,
        scaleX: 1.1,
      },
    },
  },

  {
    id: 'Mouth13',
    svg: Mouth13,
    positioning: {
      pointNarrow: {
        y: 125.14193725585938,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 124.57365417480469,
        scaleX: 1,
      },
      pointWide: {
        y: 123.60069274902344,
        scaleX: 1,
      },
      roundNarrow: {
        y: 126.44902038574219,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 125.95484924316406,
        scaleX: 1,
      },
      roundWide: {
        y: 125.73851013183594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 122.13536071777344,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 124.64010620117188,
        scaleX: 1,
      },
      squareWide: {
        y: 125.11996459960938,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth16',
    svg: Mouth16,
    positioning: {
      pointNarrow: {
        y: 125.69383239746094,
        scaleX: 1,
      },
      pointMedium: {
        y: 126.38446044921875,
        scaleX: 1,
      },
      pointWide: {
        y: 124.57283020019531,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 126.506103515625,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.2777862548828,
        scaleX: 1,
      },
      roundWide: {
        y: 127.07902526855469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 124.82026672363281,
        scaleX: 1,
      },
      squareMedium: {
        y: 126.15155029296875,
        scaleX: 1,
      },
      squareWide: {
        y: 125.8287353515625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth02',
    svg: Mouth02,
    positioning: {
      pointNarrow: {
        y: 127.80996704101562,
        scaleX: 1,
      },
      pointMedium: {
        y: 127.91036987304688,
        scaleX: 1,
      },
      pointWide: {
        y: 126.647216796875,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 127.41545104980469,
        scaleX: 1,
      },
      roundMedium: {
        y: 129.86636352539062,
        scaleX: 1,
      },
      roundWide: {
        y: 128.5460968017578,
        scaleX: 1,
      },
      squareNarrow: {
        y: 126.02139282226562,
        scaleX: 1,
      },
      squareMedium: {
        y: 128.1660919189453,
        scaleX: 1,
      },
      squareWide: {
        y: 127.61683654785156,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth05',
    svg: Mouth05,
    positioning: {
      pointNarrow: {
        y: 128.2301025390625,
        scaleX: 1,
      },
      pointMedium: {
        y: 129.86203002929688,
        scaleX: 1,
      },
      pointWide: {
        y: 127.34742736816406,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 129.8551788330078,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.748779296875,
        scaleX: 1,
      },
      roundWide: {
        y: 129.6547088623047,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 126.125244140625,
        scaleX: 1,
      },
      squareMedium: {
        y: 127.16654968261719,
        scaleX: 1,
      },
      squareWide: {
        y: 128.6699981689453,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Mouth08',
    svg: Mouth08,
    positioning: {
      pointNarrow: {
        y: 127.20429992675781,
        scaleX: 1,
      },
      pointMedium: {
        y: 128.80596923828125,
        scaleX: 1,
      },
      pointWide: {
        y: 125.60386657714844,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 127.38661193847656,
        scaleX: 1,
      },
      roundMedium: {
        y: 127.97654724121094,
        scaleX: 1,
      },
      roundWide: {
        y: 128.39456176757812,
        scaleX: 1,
      },
      squareNarrow: {
        y: 124.09774780273438,
        scaleX: 1,
      },
      squareMedium: {
        y: 126.46296691894531,
        scaleX: 1,
      },
      squareWide: {
        y: 125.58659362792969,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth11',
    svg: Mouth11,
    positioning: {
      pointNarrow: {
        y: 128.95501708984375,
        scaleX: 1,
      },
      pointMedium: {
        y: 130.06121826171875,
        scaleX: 1,
      },
      pointWide: {
        y: 127.85289001464844,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 127.81089782714844,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.83778381347656,
        scaleX: 1,
      },
      roundWide: {
        y: 128.83316040039062,
        scaleX: 1,
      },
      squareNarrow: {
        y: 126.99365234375,
        scaleX: 1,
      },
      squareMedium: {
        y: 128.030029296875,
        scaleX: 1,
      },
      squareWide: {
        y: 127.84060668945312,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth14',
    svg: Mouth14,
    positioning: {
      pointNarrow: {
        y: 128.6678009033203,
        scaleX: 1,
      },
      pointMedium: {
        y: 129.54052734375,
        scaleX: 1,
      },
      pointWide: {
        y: 128.23861694335938,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 128.74388122558594,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.7577667236328,
        scaleX: 1,
      },
      roundWide: {
        y: 129.17372131347656,
        scaleX: 1,
      },
      squareNarrow: {
        y: 125.61697387695312,
        scaleX: 1,
      },
      squareMedium: {
        y: 128.23402404785156,
        scaleX: 1,
      },
      squareWide: {
        y: 128.2870635986328,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth17',
    svg: Mouth17,
    positioning: {
      pointNarrow: {
        y: 128.86856079101562,
        scaleX: 1,
      },
      pointMedium: {
        y: 129.67724609375,
        scaleX: 1,
      },
      pointWide: {
        y: 126.84481811523438,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 128.61215209960938,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.66098022460938,
        scaleX: 1,
      },
      roundWide: {
        y: 126.88999938964844,
        scaleX: 1,
      },
      squareNarrow: {
        y: 125.04090881347656,
        scaleX: 1,
      },
      squareMedium: {
        y: 126.92695617675781,
        scaleX: 1,
      },
      squareWide: {
        y: 126.92314147949219,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth03',
    svg: Mouth03,
    positioning: {
      pointNarrow: {
        y: 126.79495239257812,
        scaleX: 1,
      },
      pointMedium: {
        y: 127.14266967773438,
        scaleX: 1,
      },
      pointWide: {
        y: 125.68246459960938,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 127.98139953613281,
        scaleX: 1,
      },
      roundMedium: {
        y: 129.57778930664062,
        scaleX: 1,
      },
      roundWide: {
        y: 127.32064819335938,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 124.63600158691406,
        scaleX: 1,
      },
      squareMedium: {
        y: 125.00053405761719,
        scaleX: 1,
      },
      squareWide: {
        y: 126.93632507324219,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Mouth06',
    svg: Mouth06,
    positioning: {
      pointNarrow: {
        y: 128.23304748535156,
        scaleX: 1,
      },
      pointMedium: {
        y: 127.5025634765625,
        scaleX: 1,
      },
      pointWide: {
        y: 125.5965576171875,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 128.53237915039062,
        scaleX: 1,
      },
      roundMedium: {
        y: 127.90969848632812,
        scaleX: 1,
      },
      roundWide: {
        y: 128.01841735839844,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 124.6617431640625,
        scaleX: 1,
      },
      squareMedium: {
        y: 127.31062316894531,
        scaleX: 1,
      },
      squareWide: {
        y: 127.45449829101562,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth09',
    svg: Mouth09,
    positioning: {
      pointNarrow: {
        y: 128.61785888671875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 127.83468627929688,
        scaleX: 0.9,
      },
      pointWide: {
        y: 126.96073913574219,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 127.88505554199219,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 127.89006042480469,
        scaleX: 1,
      },
      roundWide: {
        y: 129.28883361816406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 126.62419128417969,
        scaleX: 1,
      },
      squareMedium: {
        y: 128.9637908935547,
        scaleX: 0.9,
      },
      squareWide: {
        y: 128.17822265625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth12',
    svg: Mouth12,
    positioning: {
      pointNarrow: {
        y: 128.58689880371094,
        scaleX: 1,
      },
      pointMedium: {
        y: 128.69091796875,
        scaleX: 1,
      },
      pointWide: {
        y: 126.10476684570312,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 128.31228637695312,
        scaleX: 1,
      },
      roundMedium: {
        y: 128.53538513183594,
        scaleX: 1,
      },
      roundWide: {
        y: 128.66510009765625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 125.12979125976562,
        scaleX: 1,
      },
      squareMedium: {
        y: 127.86589050292969,
        scaleX: 1,
      },
      squareWide: {
        y: 127.78567504882812,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Mouth15',
    svg: Mouth15,
    positioning: {
      pointNarrow: {
        y: 125.04493713378906,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 124.73887634277344,
        scaleX: 1,
      },
      pointWide: {
        y: 124.67625427246094,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 125.32640075683594,
        scaleX: 1,
      },
      roundMedium: {
        y: 126.0296630859375,
        scaleX: 1,
      },
      roundWide: {
        y: 125.26211547851562,
        scaleX: 1,
      },
      squareNarrow: {
        y: 123.54376220703125,
        scaleX: 1,
      },
      squareMedium: {
        y: 124.53952026367188,
        scaleX: 1,
      },
      squareWide: {
        y: 124.08686828613281,
        scaleX: 1,
      },
    },
  },
]

export default data
